var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGutters1Story(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gutters1story",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232.33 128.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    points: "123.08 55.52 62.88 2.07 19.87 45.71 10.2 55.52 10.2 126.75 220.83 126.75 220.83 55.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    points: "19.55 15.25 19.55 45.71 34.81 30.56 34.81 15.25 19.55 15.25"
  })), /*#__PURE__*/React.createElement("polyline", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    points: "72.92 11.51 230.83 11.51 230.83 55.52 123.08 55.52 123.08 125.06"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x: 29.93,
    y: 71.57,
    width: 31.92,
    height: 55.18
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x: 75.6,
    y: 71.57,
    width: 31.92,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x: 145.8,
    y: 71.57,
    width: 54.23,
    height: 54.23
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x1: 146.58,
    y1: 90.29,
    x2: 200.03,
    y2: 90.29
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x1: 146.58,
    y1: 108.07,
    x2: 200.03,
    y2: 108.07
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x1: 1.08,
    y1: 64.92,
    x2: 10.49,
    y2: 55.24
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    x1: 132.09,
    y1: 64.92,
    x2: 122.68,
    y2: 55.24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGutters1Story);
export default __webpack_public_path__ + "static/media/gutters1story.918d0039b7c43a422fd1c52a19661455.svg";
export { ForwardRef as ReactComponent };